import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'

export function AdminRoute() {
  if (localStorage.getItem('role') !== 'ROLE_ADMIN') {
    return <Navigate to="/acessoNegado" />
  }
  return <Outlet />
}
